module.exports = __webpack_public_path__ + "static/img/WXSM.d90a70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WXSM.png
// module id = N6+U
// module chunks = 128